import { FC, useMemo } from "react";
import { getTeamColors } from "components/colors";
import { TwoSideStat } from "../../../components/common/TwoSideStat";

export const CurrentStreak: FC<{ statusText: string; status: any }> = ({
  statusText,
  status,
}) => {
  const { home: homeColor, away: awayColor } = getTeamColors(status);

  const { home, away } = useMemo(() => {
    const info = statusText?.split("|").find((p) => p.startsWith("INFO="));
    const raw = info?.substring(5) ?? "";
    const [h, a] = raw.split(":").map((x) => Number((x ?? "").trim() || 0));
    return { home: h, away: a };
  }, [statusText]);

  return (
    <TwoSideStat
      homeColor={homeColor}
      awayColor={awayColor}
      leftValue={home}
      rightValue={away}
      bottomLabel="CURRENT STREAK"
    />
  );
};
